import React from "react";

const PageTitle = ({ title }) => (
  <span className="uk-text-default uk-text-bold" style={{ fontSize: "1.5rem" }}>
    {title}
  </span>
);

export default PageTitle;
